import { render, staticRenderFns } from "./UserPlansManagement.vue?vue&type=template&id=645ee05a&scoped=true&"
import script from "./UserPlansManagement.vue?vue&type=script&lang=js&"
export * from "./UserPlansManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserPlansManagement.vue?vue&type=style&index=0&id=645ee05a&lang=scss&scoped=true&"
import style1 from "./UserPlansManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ee05a",
  null
  
)

export default component.exports